import React from 'react';
import { ColumnDatatable, RowSelectionAction } from '@europrocurement/flexy-datatable';
import { CollectionOpenSearch } from '@europrocurement/l2d-domain';
import {
    DossierPrescriber,
    useOrderTable as useDefaultOrderTable,
    useOrderFilters,
    useOrderPreFilters,
    usePanierPay,
} from '@europrocurement/l2d-modules';
import { Box, Tooltip } from '@mui/material';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { useSnackbar } from 'notistack';
import { ordersBasePath, ordersFacturationPath } from '../constants';

const useOrderTable = () => {
    const { columns } = useDefaultOrderTable();
    const { backPreFilter } = useOrderPreFilters();
    const { backOrderFilter } = useOrderFilters();
    const { navigateCollectionPay } = usePanierPay();
    const filters = backOrderFilter;

    const { enqueueSnackbar } = useSnackbar();
    const prescriberColumn: ColumnDatatable<CollectionOpenSearch> = {
        label: 'Prescripteur',
        render: ({ prescripteurLibelle, demo }) => (
            <DossierPrescriber
                label={prescripteurLibelle as string}
                demo={demo}
            />
        ),
        isDisplayed: true,
        sortable: true,
        field: 'prescripteurLibelle',
    };
    const offreColumn: ColumnDatatable<CollectionOpenSearch> = {
        label: 'Offre',
        render: ({ offreLibelle, offreIcon }) =>
            offreLibelle ? (
                <Tooltip title={offreLibelle}>
                    <Box>
                        <FaOptionIcon icon={['fasl', offreIcon || 'star'] as IconProp} />
                    </Box>
                </Tooltip>
            ) : null,
        isDisplayed: true,
        sortable: true,
        field: 'offreLibelle',
    };

    // Not available for the moment -> todo
    // columns.push({
    //     label: 'Actions',
    //     displayLabel: false,
    //     render: (collection) => <OrderActionMenu collection={collection} />,
    //     isDisplayed: true,
    //     sortable: false,
    //     sx: {
    //         display: {
    //             xs: 'none',
    //             sm: 'none',
    //             md: 'table-cell',
    //             lg: 'table-cell',
    //             xl: 'table-cell',
    //         },
    //     },
    // });
    columns.splice(2, 0, prescriberColumn);
    columns.splice(3, 0, offreColumn);

    const rowActions: RowSelectionAction[] = [
        {
            icon: 'fa-file-invoice',
            label: 'Facturer ces commandes',
            onClick: (items: Array<CollectionOpenSearch>) => {
                if (!items || items.length === 0) return;

                // Vérifie que tous les clientId sont identiques
                const clientIds = items.map((item) => item.clientId);
                const uniqueClientIds = Array.from(new Set(clientIds));
                if (uniqueClientIds.length > 1) {
                    enqueueSnackbar(
                        'Erreur : les commandes sélectionnées doivent être facturées au même client.',
                        { variant: 'error' },
                    );
                    return;
                }

                const ids = items.map((item) => item.id);
                const encodedParams = encodeURIComponent(JSON.stringify(ids));
                window.location.href = `/${ordersBasePath}/${ordersFacturationPath}`.replace(
                    ':idsOrders',
                    encodedParams as string,
                );
            },
        },
        {
            icon: 'fa-credit-card',
            label: 'Payer ces commandes',
            onClick: (items: Array<CollectionOpenSearch>) => {
                if (!items || items.length === 0) return;

                // Vérifie que tous les clientId sont identiques
                const clientIds = items.map((item) => item.clientId);
                const uniqueClientIds = Array.from(new Set(clientIds));
                if (uniqueClientIds.length > 1) {
                    enqueueSnackbar(
                        'Erreur : les commandes sélectionnées doivent être facturées au même client.',
                        { variant: 'error' },
                    );
                    return;
                }

                const ids = items.map((item) => item.id as number);

                navigateCollectionPay(ids);
            },
        },
    ];

    return { columns, filters, preFilters: backPreFilter, rowActions };
};

export default useOrderTable;
